import React from 'react';
import Gallery from './Gallery';

function GalleryPage() {
  return (
    <Gallery className= "gallery "
    ></Gallery>
  );
}

export default GalleryPage;
